import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  border: none;
  border-radius: var(--border-radius8);
  background-color: var(--color-greyF8);
  outline: none;
  cursor: pointer;
  margin: 10px 0 20px;
  padding: 0 10px;
  & > span {
    font-size: var(--font-size18);
    color: var(--color-grey6A);
  }
  @media (hover) {
    &:hover {
      background-color: var(--color-greyEC);
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const SpinnerWrap = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.5);
`;
